module.exports = {
    "collapse": `Sutraukti`,
    "expand": `I\u{161}skleisti`
};


//# sourceMappingURL=lt-LT.main.js.map
